import { newLogoReachOk64 } from 'reports/base64Images';
import { groupBy, mixtureSubstancesBySubstance } from 'selectors/generic';
import store from 'source/store';
import theme from 'source/theme';
import { MIXTURE } from 'utils/constants/coreConstants';
import { shortDate } from 'utils/helperFunctions/dateFormat';

// `rm.consumptions` was a list of ids the raw material carried; the consumption
// rows name their raw material, so one index answers it for every row.
const consumptionsByRawMaterial = groupBy('rawMaterialConsumptions', 'raw_material_id');

const rowGenerator = (rawMaterials, rawMaterialsById, consumptionsById) => {

  let consumptionsAugmentedByRmId = {};

  const state = store.getState();
  const consumptionsOf = consumptionsByRawMaterial(state);
  const mixturesOf = mixtureSubstancesBySubstance(state);

  // collect consumptions
  rawMaterials.forEach(rm => {
    const consumptionsAugmented = {};

    const rmConsumptions = consumptionsOf[rm.id] || [];
    rmConsumptions.forEach(rmC => {
      const rmCmutated = {
        ...rmC,
        name: rm.name
      };

      return consumptionsAugmented[rmC.year] ?
        consumptionsAugmented[rmC.year].push(rmCmutated) :
        consumptionsAugmented[rmC.year] = [rmCmutated];
    });


    const rmMixtures = mixturesOf[rm.id] || [];
    if (rm.type !== MIXTURE && rmMixtures.length > 0) {
      rmMixtures.forEach(interMix => {
        const percent = interMix.percentage;
        const mix = rawMaterialsById[interMix.mixture_id];

        const mixConsumptions = consumptionsOf[mix.id] || [];
        mixConsumptions.forEach(rmC => {
          const rmCmutated = {
            ...rmC,
            annual_purchase_kg: rmC.annual_purchase_kg * percent / 100,
            annual_consumption_kg: rmC.annual_consumption_kg * percent / 100,
            name: mix.name
          };

          return consumptionsAugmented[rmC.year] ?
            consumptionsAugmented[rmC.year].push(rmCmutated) :
            consumptionsAugmented[rmC.year] = [rmCmutated];
        });
      });
    }

    consumptionsAugmentedByRmId[rm.id] = consumptionsAugmented;

  });

  // transform consumptions to report
  let reportRows = [];
  rawMaterials.forEach( rm => {

    if(Object.keys(consumptionsAugmentedByRmId[rm.id]).length > 0) {
      const years = Object.keys(consumptionsAugmentedByRmId[rm.id]).sort();
      let rows = [];

      rows.push([
        { text: rm.name, fillColor: theme.palette.primary.light },
        { text: rm.cas, fillColor: theme.palette.primary.light },
        { text: rm.ec, fillColor: theme.palette.primary.light },
        { text: '', fillColor: theme.palette.primary.light },
        { text: '', fillColor: theme.palette.primary.light },
        { text: '', fillColor: theme.palette.primary.light },
      ]);

      years.forEach( year => {
        let totalBuy = 0;
        let totalConsumption = 0;

        consumptionsAugmentedByRmId[rm.id][year].forEach( consumption => {
          totalBuy = totalBuy + consumption.annual_purchase_kg;
          totalConsumption = totalConsumption + consumption.annual_consumption_kg;
           rows.push([
             '',
             '',
             year,
             consumption['name'],
             consumption['annual_purchase_kg'],
             consumption['annual_consumption_kg']]);
        });
        rows.push([
          '',
          '',
          { text: `Total`, bold: true, fillColor: '#EEEEEE' },
          { text: ``, bold: true, fillColor: '#EEEEEE' },
          { text: totalBuy, bold: true, fillColor: '#EEEEEE' },
          { text: totalConsumption, bold: true, fillColor: '#EEEEEE' }
        ]);
      });


      reportRows = [...reportRows, ...rows];
    }
  });

  return reportRows;
};

const dd = (rawMaterialsData, rawMaterialsById, consumptionsById) => ({
  pageSize: 'A4',
  pageOrientation: 'landscape',
  pageMargins: [40, 60, 40, 40],

  footer: function (currentPage, pageCount) {
    return {
      text: `${shortDate(new Date())} - ${currentPage.toString()} de ${pageCount}`,
      alignment: 'right',
      relativePosition: { x: -15, y: 20 },
      fontSize: 7
    };
  },
  header: function (currentPage, pageCount, pageSize) {
    return [
      {
        image: newLogoReachOk64,
        width: 50,
        relativePosition: { x: 20, y: 10 }
      }
    ];
  },
  content: [
    {
      style: 'header',
      text: 'R - Consumo Anual de Substâncias' //title,
    },
    {
      style: 'tableExample',
      layout: 'headerLineOnly',
      // layout: 'lightHorizontalLines',
      table: {
        headerRows: 1,
        widths: ['*', 100, 100, 100, 100, 100],
        body: [
          [
            '', 'CAS', 'EC', 'ANO', 'COMPRA (Kg)', 'CONSUMO (Kg)'
          ],
          ...rowGenerator(rawMaterialsData, rawMaterialsById, consumptionsById)

        ]
      }
    }
  ],
  styles: {
    header: {
      color: theme.palette.primary.main,
      fontSize: 16,
      bold: true,
      alignment: 'center'
    },
    tableExample: {
      margin: [0, 15, 0, 0],
      fontSize: 8
    }
  }

});

export default dd;
